import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Layout from '../components/Layout';
import { logout } from '../redux/auth';
import { loadData } from '../redux/data';
import { retrieveProfile } from '../redux/profile';
import { tryParkingLogout } from '../redux/parkingAuth';

import { openDialog } from '../redux/alert';

const mapStateToProps = ({ auth, profile, parkingAuth }) => ({
  ...auth,
  ...profile,
  profileImage: profile.profile_image,
  loggedInPark: parkingAuth.loggedInPark,
  // status: profile.status,
});

const mapDispatchToProps = dispatch => ({
  logout: history => dispatch(logout(history)),
  retrieveProfile: () => dispatch(retrieveProfile()),
  tryParkingLogout: () => dispatch(tryParkingLogout()),
  loadData: () => dispatch(loadData()),
  openDialog: dialogType => dispatch(openDialog(dialogType)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));



// WEBPACK FOOTER //
// ./src/containers/Layout.js